import React from 'react'

import { useAuth } from '#hooks/useAuth'

import type { IProps } from './interfaces'

export const RoleGuard = ({ requiredRole, children, fallback = null }: IProps): React.ReactNode => {
  const { hasMinimumRole } = useAuth()

  if (!hasMinimumRole(requiredRole)) return fallback

  return <>{children}</>
}
